import { getFingerprint } from '@rendora/common/utils/fingerprint';
import { getChannel } from '@rendora/common/utils/report';
import { getLocation, postUploadBehavior } from '~/api/module/seo';
import { SESSION_QUERY_PASSTHROUGH } from '~/constants/config';

export enum UNIQ_BEHAVIOR {
  CLICK_SUBSCRIBE = '/subscribe/click', // 点击订阅
}

// BI 埋点
let persistCountry: string | undefined;
export async function trackUploadBehavior(behavior: string | UNIQ_BEHAVIOR) {
  const runtimeConfig = useRuntimeConfig();
  if (runtimeConfig.public.privatization) {
    return;
  }
  if (import.meta.client) {
    const { isMobile } = useDevice();

    // 同步埋点数据到bi所需随机用户id
    const fingerprint = await getFingerprint();
    // 只上报一次
    const {
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      from,
      ref,
      keyword_search,
    } = sessionGetItem(SESSION_QUERY_PASSTHROUGH) || {};
    const country = persistCountry || (await getLocation()).country;

    postUploadBehavior({
      behavior,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      session_id: fingerprint,
      country,
      refer: window.document.referrer,
      keyword_search,
      gclid: getChannel().gclid,
      source: from || ref,
      platform: isMobile ? 'mobile' : 'pc',
    });
  }
}
